import { useTranslation } from "react-i18next";
import InfoTip from "../../../components/InfoTip";
import { ActivityMetricInfoIcon } from "../../../components/ActivityDetailMetricIcons";

const MaterialsCatalogHeader = () => {
  const { t } = useTranslation();

  return (
    <article className="table-standard-header">
      <div className="table-standard-header-cell">
        {t("materialsCatalog.colMaterial")}
      </div>
      <div className="table-standard-header-cell">
        {t("materialsCatalog.colCategory")}
      </div>
      <div className="table-standard-header-cell">
        {t("materialsCatalog.colScope")}
        <InfoTip widthMaxRem={20} icon={<ActivityMetricInfoIcon />}>
          <p className="m-0 text-[13px] leading-tight opacity-90">
            {t("materialsCatalog.scopeHelp")}
          </p>
        </InfoTip>
      </div>
      <div className="table-standard-header-cell">
        {t("materialsCatalog.colRecyclability")}
        <InfoTip widthMaxRem={20} icon={<ActivityMetricInfoIcon />}>
          <p className="m-0 mb-2 text-[13px] leading-tight opacity-90">
            {t("materialsCatalog.recyclabilityHelpTheory")}
          </p>
          <p className="m-0 text-[13px] leading-tight opacity-90">
            {t("materialsCatalog.recyclabilityHelpPractice")}
          </p>
        </InfoTip>
      </div>
      <div className="table-standard-header-cell">
        {t("materialsCatalog.colColorCode")}
      </div>
    </article>
  );
};

export default MaterialsCatalogHeader;
